import AnimatedIndicator from '@/components/AnimatedIndicator/AnimatedIndicator'
import AnimatedScore from '@/components/AnimatedScore/AnimatedScore'
import { useTheme } from '@/contexts/ThemeContext'
import './BarScore.css'

import type { FC } from 'react'

export interface BarScoreProps {
  homeScore: number
  awayScore: number
  homeControl?: boolean
  awayControl?: boolean
  style?: React.CSSProperties
}

const MULTIPLIERS = {
  scoreLineHeight: 1.25,
  scoreFontSize: 1.75,
  scoreGapSize: 0.3,
  controlSize: 0.25,
  gapSize: 0.167,
}

const BarScore: FC<BarScoreProps> = ({ homeScore, awayScore, homeControl = false, awayControl = false, style }) => {
  const theme = useTheme()

  return (
    <div className="bar-score" style={{ ...style }}>
      <div
        className="bar-score-team"
        style={{ gap: `calc(${theme.baseHeight} * ${MULTIPLIERS.scoreGapSize})`, width: '45%' }}
      >
        <AnimatedScore
          value={homeScore}
          className="bar-score-value"
          style={{
            fontSize: `calc(${theme.baseHeight} * ${MULTIPLIERS.scoreFontSize})`,
            lineHeight: `calc(${theme.baseHeight} * ${MULTIPLIERS.scoreLineHeight})`,
          }}
        />
        <AnimatedIndicator
          isActive={homeControl}
          className="bar-score-control"
          style={{
            width: `calc(${theme.baseHeight} * ${MULTIPLIERS.controlSize})`,
            height: `calc(${theme.baseHeight} * ${MULTIPLIERS.controlSize})`,
          }}
        />
      </div>
      <span
        className="bar-score-separator"
        style={{
          fontSize: `calc(${theme.baseHeight} * ${MULTIPLIERS.scoreFontSize})`,
          lineHeight: `calc(${theme.baseHeight} * ${MULTIPLIERS.scoreLineHeight})`,
          width: '10%',
        }}
      >
        -
      </span>
      <div
        className="bar-score-team"
        style={{ gap: `calc(${theme.baseHeight} * ${MULTIPLIERS.scoreGapSize})`, width: '45%' }}
      >
        <AnimatedScore
          value={awayScore}
          className="bar-score-value"
          style={{
            fontSize: `calc(${theme.baseHeight} * ${MULTIPLIERS.scoreFontSize})`,
            lineHeight: `calc(${theme.baseHeight} * ${MULTIPLIERS.scoreLineHeight})`,
          }}
        />
        <AnimatedIndicator
          isActive={awayControl}
          className="bar-score-control"
          style={{
            width: `calc(${theme.baseHeight} * ${MULTIPLIERS.controlSize})`,
            height: `calc(${theme.baseHeight} * ${MULTIPLIERS.controlSize})`,
          }}
        />
      </div>
    </div>
  )
}

export default BarScore
